import { gql } from '@/__generated__';

export const refundCustomerSearchDocument = gql(/* GraphQL */ `
  query RefundCustomerSearch(
    $where: CustomerWhereInput
    $orderBy: [CustomerOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    customers(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      name
      avatar
      createdAt
      updatedAt
      active
      reason
      _count {
        orders
        refunds
      }
    }
  }
`);

export const refundCustomerOrdersDocument = gql(/* GraphQL */ `
  query RefundCustomerOrders(
    $where: OrderWhereInput
    $orderBy: [OrderOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    orders(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      package
      status
      total
      shippingMethod {
        id
        name
      }
      paymentMethod {
        id
        name
      }
      createdAt
      updatedAt
      lines {
        id
        type
        code
        name
        status
        price
        description
      }
    }
  }
`);

export const refundStatisticsDocument = gql(/* GraphQL */ `
  query RefundStatistics($where: RefundWhereInput!) {
    refunds(where: $where) {
      id
      status
      iban
      reason
      amount
      createdAt
    }
  }
`);

export const countRefundsDocument = gql(/* GraphQL */ `
  query CountRefunds($where: RefundWhereInput!) {
    countRefunds(where: $where)
  }
`);

export const refundsDocument = gql(/* GraphQL */ `
  query Refunds(
    $where: RefundWhereInput
    $orderBy: [RefundOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    refunds(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      status
      reason
      note
      amount
      iban
      customerId
      createdAt
      updatedAt
      exportedAt
      processedAt
      lines {
        id
        type
        code
        name
        status
        price
        description
        order {
          id
          package
        }
      }
      customer {
        id
        avatar
        name
      }
      _count {
        lines
      }
    }
  }
`);

export const refundDocument = gql(/* GraphQL */ `
  query Refund($where: RefundWhereUniqueInput!) {
    refund(where: $where) {
      id
      status
      reason
      note
      amount
      iban
      customerId
      createdAt
      updatedAt
      exportedAt
      processedAt
      customer {
        id
        name
        email
        iban
      }
      lines {
        id
        name
        code
        price
        order {
          id
          package
        }
      }
    }
  }
`);
